
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { saveAs } from 'file-saver';
import { GLOBAL } from './global';
import { map } from 'rxjs/operators';
import { Http, Headers } from "@angular/http";
import { Observable } from "rxjs";

@Injectable()
export class wsGenerarPDFService {
    public url;

    constructor(
        private _http2: HttpClient,
        private _http: Http
    ) {
        this.url = GLOBAL.url;
    }

    downloadDocuments(doc_name) {
        console.log("entre a servicio", this.url);

        const params = {

        };


        const headers = new HttpHeaders({
            /* 'Authorization': sessionStorage.getItem("token-domCloud") */
        })

        return this._http2.post(this.url + 'get/downloadPDF', params, { headers, responseType: "blob" }).toPromise()
            .then(blob => {
                console.log(blob)
                saveAs(blob, doc_name);
            })
            .catch(err => console.log("download error = ", err))
    }




    getBase64(dataHtml, color): Observable<any> {
        let params = {
            dataHtml: dataHtml,
            color: color
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
        })

        return this._http2.post(this.url + 'get/base64Pdf', params, { headers: headers })
            .pipe(map((res: any) => res));
    }

}